import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';


const StyledButton = styled(Button)(({ theme }) => ({
    textTransform: 'uppercase',
    letterSpacing: '0.0714em',
    fontWeight: 500,
    fontSize: '14px',
    padding: '6px 14px',
    '&:hover': {
        backgroundColor: '#0056b3'
    },
    '&.MuiButton-outlined:hover': {
        backgroundColor: '#F8FAFF'
    },
    borderRadius: '8px'
}));

export default StyledButton;